import { h } from "preact"
import { useEffect, useState } from "preact/hooks";

import Image from 'utils/image';

const renderProductCard = (product) => {

  const productImageSrc = 
  Array.isArray(product.image) ? product.image[0] : product.image
  const alt = product.alt ? product.alt : product.featured_image.alt
  
  return(
    <div
      className="relative"
      key={product.title}
    >
      <a
        className="no-underline"
        href={`/products/${product.handle}`}
        tabIndex="-1"
        aria-label={product.title}
      >
       <Image
        src={productImageSrc || window.TMW.Strings.placeholder_image}
        classes="min-h-[148px] object-cover mb-2"
        customSize={300}
        alt={alt}
      /> 

      <p
        className="font-light paragraph-4 [&>strong]:font-medium first-letter:uppercase"
        dangerouslySetInnerHTML={{ __html: product.styled_text }}
      />
        <span className="hidden">
          {product.title}
        </span>
      </a>
    </div>
  )
}


const highlightSubstring = (originalString, substring) => {
  const indexStart = originalString.indexOf(substring);

  if (indexStart === -1) {
    return originalString;
  }

  const stringStart = originalString.substring(0, indexStart);
  const stringEnd = originalString.substring(indexStart + substring.length);

  return `${stringStart}<strong>${substring}</strong>${stringEnd}`;
}

const renderProducts = (products, searchQuery) => (
  <div className="grid grid-cols-2 gap-x-[10px] gap-y-6 mb-8 pb-10 border-b border-b-grey-3">
    {products.map((product) => {
      let styledText = product.title;
      const titleWords = product.title.toLowerCase();

      if (titleWords.includes(searchQuery)) {
        styledText = highlightSubstring(titleWords, searchQuery)
      }

      return (
        renderProductCard({
          ...product,
          styled_text: styledText
        })
      )
    })}
  </div>
);

const SearchResults = ({ defaultData }) => {
  const [searchQuery, setSearchQuery] = useState([]);
  const [suggestion, setSuggestion] = useState([]);
  const { title, products: defaultProducts } = defaultData;
  const isNoResults = searchQuery.length > 0
    && suggestion?.products?.length === 0;

  const handleSearch = ({ detail }) => {
    const { results, query } = detail.payload;

    if (!results) {
      setSuggestion([]);
      return;
    }

    setSuggestion(results);
    setSearchQuery(query);
  };

  useEffect(() => {
    document.addEventListener('search', handleSearch);

    return () => {
      document.removeEventListener('search', handleSearch)
    }
  }, []);

  return (
    <div className="my-5">
      <p className="paragraph-3 uppercase !font-medium mb-4">{title}</p>

      {searchQuery.length < 2 && renderProducts(defaultProducts, searchQuery)}

      {isNoResults &&
        <p className="mb-10 mt-5 pb-10 border-b border-b-grey-3">
          {window.TMW.Strings.search.noResults}
          <strong>&ldquo;{searchQuery}&rdquo;</strong>
        </p>
      }

      {searchQuery.length > 1
        && suggestion?.products?.length > 0
        && renderProducts(suggestion.products, searchQuery)}
    </div>
  )
};

export default SearchResults;

